export default {
    confirm: 'Yes, copy now',
    content: 'You are copying the work space <u>including</u> the micro- and macro-trends as well as existing search agents for all participants.',
    success: 'The work space was successfully copied.',
    title: 'Are you sure you want to copy the work space "{title}" ?',
    titlePrefix: 'Copy',
    form: {
        title: {
            label: 'Title'
        }
    }
}
